import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID, TransferState } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from 'src/app/shared/services/meta.service';
import { CustomerspagesService } from '../customerspages.service';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CaseStudyHeroComponent } from './case-study-hero/case-study-hero.component';
import { CaseStudyApiComponent } from './case-study-api/case-study-api.component';
import { CaseStudyStoriesComponent } from './case-study-stories/case-study-stories.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { data } from 'src/app/shared/components/topnavigation/topnavigation';
import { isPlatformServer } from '@angular/common';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-case-study',
  templateUrl: './case-study.component.html',
  styleUrls: ['./case-study.component.scss'],
  imports: [
    CaseStudyHeroComponent,
    CaseStudyApiComponent,
    CaseStudyStoriesComponent,
    CommonGetstartedComponent,
  ],
})
export class CaseStudyComponent implements OnInit {
  artData:any;
  getStartedData:any;
  keyName: any = '';
  pageData: any;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  constructor(
    private customersPagesService: CustomerspagesService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: string,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }
  ngOnInit(): void {
    this.keyName = this.route.snapshot.params['casestudyID'].split('-').join('_');
    this.route.params.subscribe(param => {
      const casestudyID = param?.['casestudyID'];
      const seoData = this.route.snapshot.data?.['seo'];
      
      const selectedSeoData = seoData.find(
        (seo:any) => seo?.fields?.webPageId.toLowerCase() === casestudyID.toLowerCase()
      );
      this.pageData = seoData?.filter((el:any) => el?.fields?.webPageId.toLowerCase() === casestudyID.toLowerCase())?.[0]?.fields;
      this.metaBody.title = selectedSeoData?.fields?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
      this.metaBody.description = selectedSeoData?.fields?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
      this.metaBody.type = 'Customer Stories';
      this.metaBody.url = this.getUrl;
      this.metaBody.image = selectedSeoData?.fields?.customerStoryHeroPanel?.fields?.image?.[0]?.fields?.file?.url;
      this.meta.updateOG(this.metaBody);
      this.meta.updateMeta(
        selectedSeoData?.fields?.seoMetadataReference?.fields
      );
      this.customersPagesService.getArticleData(param?.['casestudyID']);
      if (this.pageData != null && this.pageData?.gettingStartedPanel) {
        let started = this.pageData?.gettingStartedPanel?.fields;
        this.getStartedData = {
          header: started?.title,
          button1: {
            url: started?.buttons?.[0]?.fields?.redirectLink,
            text: started?.buttons?.[0]?.fields?.buttonText,
            target: started?.buttons?.[0]?.fields?.actionType,
          },
          button2: {
            url: started?.buttons?.[1]?.fields?.redirectLink,
            text: started?.buttons?.[1]?.fields?.buttonText,
            target: started?.buttons?.[1]?.fields?.actionType,
          },
        };
      }
    });
    this.canonical.setCanonicalURL();
    this.posthogService.capturePageViewEvent(this.keyName);
  }
  async setData(data:any) {
    if (isPlatformServer(this.platformId)) {
      this.transferState.set(this.keyName, this.getStartedData);
    }
    this.cdr.detectChanges();
  }
}
